// extracted by mini-css-extract-plugin
export default {"header":"FormHeader_header__ElsGz","number":"FormHeader_number__5m9zT","title":"FormHeader_title__-yprM"};